import { defineComponent, computed } from "vue";
import { storeToRefs } from "pinia";
import { useMaintenanceScheduleStore } from "../maintenanceScheduleStore";
export default defineComponent({
    name: "MaintenanceScheduleTrim",
    setup() {
        const store = useMaintenanceScheduleStore();
        const { questionModelAnswer, questionTrimAnswer, questionTrimAnswers } = storeToRefs(store);
        const showTrimQuestion = computed(() => questionModelAnswer.value !== undefined);
        const fieldIsDisabled = computed(() => {
            return questionModelAnswer.value === undefined;
        });
        function answered(event) {
            if (fieldIsDisabled.value) {
                event.preventDefault();
                return;
            }
            store.updateQuestionTrimAnswer();
            const mileageQuestionContainer = document.querySelector("#maintenanceScheduleQuestionFour");
            mileageQuestionContainer.removeAttribute("aria-hidden");
        }
        return {
            questionTrimAnswers,
            questionTrimAnswer,
            answered,
            fieldIsDisabled,
            showTrimQuestion,
        };
    },
});
